
  import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
  import { Validations } from 'vuelidate-property-decorators';
  import { required, minValue, maxLength } from 'vuelidate/lib/validators';
  import { EnumModel, AreaType, AreaTypeEnums } from '@/common/enumerations';
  import * as StringUtils from '@/utilities/string.utils';
  import {
    Client,
    TravelTimeModel,
    TravelTimeCreateModel,
    ValidationProblemDetails,
    ProblemDetails
  } from '@/services/api.service';
  import { EventBus } from '@/event-bus';
  import { TravelTimeCreatedMessage } from '@/services/eventbus.models';

  @Component({})
  export default class TravelTimeCreate extends Vue {
    private locality: string = '';
    private postcode: string = '';
    private areaType: EnumModel | null = null;
    private travelTimeInHours: number = 0;
    private travelTimeInMinutes: number = 0;

    private availableAreaTypes: EnumModel[] = [];
    private serverErrors = new Array<{ key: string; errors: string[] }>();

    public formIsValid: boolean | null = null;
    public isServiceProcessing: boolean = false;

    @Validations()
    private validations = {
      locality: { required },
      postcode: { required }
    };

    private mounted() {
      this.availableAreaTypes.push(...AreaTypeEnums);
      this.areaType = this.availableAreaTypes[0];
    }

    private createTravelTime() {
      // Do the work here
      // Run the validation
      this.isServiceProcessing = true;
      // @ts-ignore
      this.$v.$touch();
      const me = this;
      // @ts-ignore
      if (me.$v.$invalid) {
        this.formIsValid = false;
        console.log('Submit failed. Form is invalid.');
        this.isServiceProcessing = false;
      } else {
        // do your submit logic here
        me.formIsValid = true;
        console.log('Submit started. Form valid.');
        const newTravelTime: TravelTimeCreateModel = new TravelTimeCreateModel();
        const travelTime: number = +(this.travelTimeInHours * 60) + +this.travelTimeInMinutes;
        this.serverErrors = [];
        newTravelTime.init({
          locality: this.locality,
          postcode: this.postcode,
          areaType: (this.areaType && this.areaType.value) || AreaType.Urban,
          timeInMinutes: travelTime
        });
        console.log(newTravelTime);
        const clientService: Client = new Client(process.env.VUE_APP_API_URL, this.$http);
        // @ts-ignore
        me.$Progress.start();
        clientService
          .createTravelTime(newTravelTime)
          .then((data: TravelTimeModel) => {
            // Route to the edit job list screen?
            console.log('Returned travel time:');
            console.log(data);
            // @ts-ignore
            me.$Progress.finish();
            // @ts-ignore
            me.$awn.success('Travel time for ' + me.locality + ' created successfully');
            me.$emit('traveltime-created', data);
            EventBus.$emit('traveltime-created', new TravelTimeCreatedMessage(data));
            me.closeModal();
          })
          .catch(reason => {
            console.log({ reason });

            if (reason instanceof ValidationProblemDetails) {
              const errMsg = 'There were validation errors creating the travel time for ' + me.locality + ': <br/><br/>' + reason.detail;
              // @ts-ignore
              me.$Progress.finish();
              // @ts-ignore
              me.$awn.warning(errMsg, {durations: {warning: 0}});
              this.isServiceProcessing = false;
            } else if (reason instanceof ProblemDetails) {
              const errMsg = 'Travel time for ' + me.locality + ' failed to create: <br/><br/>' + reason.detail;
              // @ts-ignore
              me.$Progress.finish();
              // @ts-ignore
              me.$awn.alert(errMsg);
              this.isServiceProcessing = false;
            }

          });
      }
    }

    private checkIfTravelTimeIsAlreadyMapped() {
      if (this.postcode && this.locality) {
        const clientService: Client = new Client(process.env.VUE_APP_API_URL, this.$http);
      }
    }
    private cancelEdit() {
      console.log('Cancelling edit...');
      // this.$emit('close');
      this.closeModal();
    }

    private closeModal() {
      this.$modal.hide('modal-traveltime-create');
    }
  }
